// This provides 4 ways to open a zoom image:
// 1. imageUrl is a direct URL to the correct image/variant
// 2. imageElement is for pre-rendered HTML passed in as a string
// 3. linkSource is an URL that fetches the final image URL (useful when images can't be preloaded)
// 4. useSrc means that the root element is an `<img>` tag and its `src` attribute is used for the zoom image
export const imageZoom = ({ imageUrl, imageElement, linkSource, useSrc }) => ({
  imageUrl,
  imageElement,
  linkSource,
  useSrc,

  init() {
    this.$root.addEventListener('click', async () => {
      if (this.linkSource && !this.imageUrl) {
        const req = new FetchRequest('get', this.linkSource, { responseKind: 'json' })
        const res = await req.perform()
        if (res.ok) {
          this.imageUrl = (await res.json).url
        }
      } else if (this.useSrc) {
        this.imageUrl = this.$root.src
      }
      this.openZoomDialog()
    })
  },

  openZoomDialog() {
    const dialog = document.createElement('dialog')
    dialog.classList.add('image-zoom-dialog')

    // Pre-rendered elements can be rendered as-is, image URLs are put in an <img> tag
    if (this.imageElement) {
      dialog.insertAdjacentHTML('afterbegin', this.imageElement)
    } else {
      const zoomedImage = document.createElement('img')
      zoomedImage.src = this.imageUrl

      // SVGs can be rendered at full width by default
      if (this.imageUrl.slice(-4) === '.svg') {
        zoomedImage.style.width = '100vw'
      }

      dialog.appendChild(zoomedImage)
    }

    const closeButton = document.createElement('button')
    closeButton.type = 'button'
    closeButton.classList.add('close-zoom', 'material-icons')
    closeButton.innerText = 'close'

    dialog.appendChild(closeButton)
    document.body.appendChild(dialog)
    document.body.classList.add('disable-scroll')
    dialog.showModal()

    // Remove the dialog when clicking on its backdrop or the close button
    dialog.addEventListener('click', (e) => e.target === dialog && this.closeZoomDialog())
    dialog.querySelector('.close-zoom').addEventListener('click', () => this.closeZoomDialog())
  },

  closeZoomDialog() {
    document.querySelector('.image-zoom-dialog').remove()
    document.body.classList.remove('disable-scroll')
  },
})
